/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { LinkSelectContext } from "cms/links/link-selector/context/select";
import SearchFilter from "cms/links/link-selector/dialog-select/select/link-search-filter-list";
import { LinkListGallery } from "cms/links/link-selector/dialog-select/select/link_list_gallery";
import { useMountedState } from "react-use";

const LinkDialogSelectPanel = () => {
    
    const {
        links = [],
        setLinks,
        searchFunction,
        needsRefresh,
        setNeedsRefresh,
    } = useContext(LinkSelectContext);
    const mounted = useMountedState();
    
    return (
        <Fragment>
  
            <div style={{ flex: "3 0 auto" }}>
                <SearchFilter
                    items={links}
                    setItems={setLinks}
                    autoLoad={true}
                    searchFunction={searchFunction}
                    needsRefresh={needsRefresh}
                    setNeedsRefresh={setNeedsRefresh}
                    instruction={"Select from existing links"}
                    mounted={mounted}
                >
                        
                    <LinkListGallery />
                    
                </SearchFilter>
            </div>
            
        </Fragment>
    );
};

export { LinkDialogSelectPanel };
